import { RootState } from "store";

export const getIsOnlineLectureWidgetOpen = (state: RootState) =>
  state.onlineLectureWidget.isOpen;

export const getOnlineLectureWidgetChatMessages = (state: RootState) =>
  state.onlineLectureWidget.chatMessage;
